import React, { useState, useEffect } from 'react';
import { X, Calendar, Clock, Save } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const RescheduleColloquioModal = ({ isOpen, onClose, colloquio, onSuccess }) => {
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (colloquio) {
      // Supporta sia il formato da ColloquiList che da CalendarioColloqui
      if (colloquio.data_colloquio) {
        // Formato ColloquiList
        setNewDate(colloquio.data_colloquio);
        setNewTime(colloquio.ora_colloquio || '09:00');
      } else if (colloquio.interview_date) {
        // Formato CalendarioColloqui (da match)
        const date = new Date(colloquio.interview_date);
        setNewDate(date.toISOString().split('T')[0]);
        setNewTime(date.toTimeString().split(' ')[0].substring(0, 5));
      }
    }
  }, [colloquio]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      // Determina l'ID corretto
      const richiestaId = colloquio.colloquio_id || colloquio.id;
      
      if (!richiestaId) {
        throw new Error('ID colloquio non trovato');
      }

      await axios.patch(
        `${API}/api/v1/richieste-colloquio/${richiestaId}`,
        {
          data_colloquio: newDate,
          ora_colloquio: newTime
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (err) {
      console.error('Errore durante lo spostamento del colloquio:', err);
      setError('Impossibile spostare il colloquio. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  // Prevent background scroll
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Ottieni il nome del candidato dal formato corretto
  const candidatoNome = colloquio.candidato?.nome || colloquio.candidate_name || 'Candidato';
  const candidatoCognome = colloquio.candidato?.cognome || '';
  const dataAttuale = colloquio.data_colloquio || (colloquio.interview_date ? new Date(colloquio.interview_date).toLocaleDateString('it-IT') : '');
  const oraAttuale = colloquio.ora_colloquio || (colloquio.interview_date ? new Date(colloquio.interview_date).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" style={{overflow: 'hidden'}}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-gray-100 flex flex-col" style={{minHeight: '400px'}}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Sposta Colloquio</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          {/* Info Colloquio */}
          <div className="mb-6 p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Candidato:</span>{' '}
              {candidatoNome} {candidatoCognome}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Data attuale: {dataAttuale} {oraAttuale && `alle ${oraAttuale}`}
            </p>
          </div>

          {/* Nuova Data */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Calendar className="w-4 h-4 inline mr-1" />
              Nuova Data
            </label>
            <input
              type="date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Nuovo Orario */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Clock className="w-4 h-4 inline mr-1" />
              Nuovo Orario
            </label>
            <input
              type="time"
              value={newTime}
              onChange={(e) => setNewTime(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
            >
              Annulla
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <Save className="w-4 h-4" />
              {loading ? 'Salvataggio...' : 'Conferma'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RescheduleColloquioModal;
